import Typography from "../Typography";

const Pagination = ({ currentPage = 1, totalPages = 1, onPageChange, className = "" }) => {
  const pages = [];
  const maxVisiblePages = 5;

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-end gap-2 ${className}`}>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 text-sm border border-border-primary rounded-sm text-text-primary bg-surface-primary hover:bg-surface-secondary disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Previous
      </button>

      {startPage > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            className="px-3 py-1 text-sm border border-border-primary rounded-sm text-text-primary bg-surface-primary hover:bg-surface-secondary transition-colors"
          >
            1
          </button>
          {startPage > 2 && (
            <Typography variant="text2" component="span" className="px-2 text-text-secondary">
              ...
            </Typography>
          )}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`px-3 py-1 text-sm border rounded-sm transition-colors ${
            currentPage === page
              ? "bg-theme-primary text-white border-theme-primary"
              : "border-border-primary text-text-primary bg-surface-primary hover:bg-surface-secondary"
          }`}
        >
          {page}
        </button>
      ))}

      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && (
            <Typography variant="text2" component="span" className="px-2 text-text-secondary">
              ...
            </Typography>
          )}
          <button
            onClick={() => onPageChange(totalPages)}
            className="px-3 py-2 text-sm border border-border-primary rounded-sm text-text-primary bg-surface-primary hover:bg-surface-secondary transition-colors"
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 text-sm border border-border-primary rounded-sm text-text-primary bg-surface-primary hover:bg-surface-secondary disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
